import { motion } from 'framer-motion';

const Forward = ({ ...props }) => (
  <motion.svg xmlns='http://www.w3.org/2000/svg' width='7' height='12' viewBox='0 0 7 12' fill='none' {...props}>
    <path
      d='M0.202807 10.872C-0.0674791 11.1292 -0.0674791 11.5499 0.202807 11.8071C0.473094 12.0643 0.915322 12.0643 1.18561 11.8071L6.79728 6.46761C7.06757 6.21043 7.06757 5.78965 6.79728 5.53248L6.79719 5.53239L1.18552 0.192883C0.91523 -0.0642945 0.473001 -0.0642945 0.202715 0.192883C-0.0675717 0.450061 -0.0675717 0.870841 0.202715 1.12802L5.32304 6L0.202807 10.872Z'
      fill='currentColor'
    />
  </motion.svg>
);

export default Forward;
